import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

import { getSrc } from "gatsby-plugin-image";

const ImageCarousel = ({ roomImages, RoomTitle }) => {
  const carouselItems = roomImages.map((image, index) => {
    return (
      <Carousel.Item key={index}>
        <img
          className="d-block w-100"
          src={getSrc(image.childImageSharp.gatsbyImageData)}
          alt={RoomTitle}
          style={{ objectFit: "cover", maxHeight: "539px" }}
        />
      </Carousel.Item>
    );
  });

  return <Carousel>{carouselItems}</Carousel>;
};

export default ImageCarousel;
